<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Informations patient</div>
        <div class="modal-body">
            <p>Informations connue du patient</p>
            <p>Nom : <b>{{ nom }}</b></p>
            <p>Prénom : <b>{{ prenom }}</b></p>
            <p>Date de naissance : <b>{{ dateNaissanceDisplay }}</b></p>
            <p>INS : <b>{{ nirAssure }}</b></p>
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <div class="col-container">
                    <frg-form-input label="Rang naissance" required="true" id="rangNaissance" type="number" [formGroup]="formGroup"
                        [control]="formGroup.get('rangNaissance')" class="patient-form-input">
                    </frg-form-input>
                    <frg-form-input label="Régime" required="true" id="regime" type="ngSelect" [formGroup]="formGroup"
                        [control]="formGroup.get('regime')" class="patient-form-input" [selectValue]="regimeArr">
                    </frg-form-input>
                    <div class="caisse-centre">
                        <frg-form-input label="Caisse" required="true" id="caisse" [formGroup]="formGroup"
                            [control]="formGroup.get('caisse')" class="patient-form-input">
                        </frg-form-input>
                        <frg-form-input label="Centre" required="true" id="centre" [formGroup]="formGroup"
                            [control]="formGroup.get('centre')" class="patient-form-input">
                        </frg-form-input>
                    </div>
                    <frg-form-input label="Type de pièce justificative" required="true" id="naturePieceJustif" type="ngSelect" [formGroup]="formGroup"
                        [control]="formGroup.get('naturePieceJustif')" class="patient-form-input" [selectValue]="naturePieceJustifArr">
                    </frg-form-input>
                </div>
                <div class="button-wrapper">
                    <div class="buttons">
                        <frg-button (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'">Annuler</frg-button>
                        <frg-button [type]="'submit'" [disabled]="!formGroup.valid" [backgroundColor]="'var(--primary)'">Continuer</frg-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>